<template>
 
   <!-- {{this.$route.query}} -->
<div>
    <b-row>
    <b-col>
      <!-- <b-img style="width: 100%; height: 200px;" thumbnail fluid src="../assets/images/fahfon/banner-plus.png"></b-img> -->
  
        <img style="width: 100%; height: 160px;" :src="bannerPath">
    </b-col>
  
  </b-row > 
     <b-row  style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <span style="color: black;">รายการที่สั่งซื้อ</span>
    </b-col>
     <b-col style="text-align: right;" align-v="center">
       <span style="color: black;">ฟ้าฝน {{packageData.type}}</span>
    </b-col>
  </b-row>


     <b-row  style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <span style="color: black;">ค่าสมาชิกต่อปี</span>
    </b-col>
     <b-col style="text-align: right;" align-v="center">
       <span style="color: black; font-weight:bold;">{{packageData.fullPrice}} บาท</span>
    </b-col>
  </b-row>
     <b-row v-if="packageData.discount !== 0"  style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <span style="color: black;">ลดพิเศษเหลือเพียง</span>
    </b-col>
     <b-col style="text-align: right;" align-v="center">
       <span style="color: black;">{{packageData.amount}} บาท</span>
    </b-col>
  </b-row>

     <b-row  style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <span style="color: black;">จำนวนเงินที่ต้องชำระ</span>
    </b-col>
     <b-col style="text-align: right;" align-v="center">
       <span style="color: black;  font-weight:bold;">{{packageData.amount}} บาท</span>
    </b-col>
  </b-row>
<hr>
     <b-row  style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <h5 style="color: black;">วิธีการชำระเงิน</h5>
    </b-col>
     <b-col style="text-align: right;" align-v="center">
       <div @click="showModal" style="color: #68C191;">เลือกวิธีการชำระเงิน</div>
    </b-col>
  </b-row>

  <b-row v-if="Object.keys(card).length !== 0" style="padding-left: 30px; padding-right: 30px;" class="mt-4" align-v="center">
    <b-col >
        <span style="color: black;">บัตรเดบิต/บัตรเครดิต</span>
    </b-col>
 <b-col style="text-align: right;" align-v="center">
       <span style="color: black;" v-if="card.cardNumberNotMask !== undefined">{{getHiddenCreditCard(card.cardNumberNotMask)}}</span>
    </b-col>
  </b-row>
<hr>
  <b-row  v-if="Object.keys(card).length !== 0" style="padding-left: 30px; padding-right: 30px;" class="mt-4"  align="center">
    <b-col align-self="center">
        <div @click="paymentSubmitCredit" style="width: 280px; height: 35px; background-color: #68C191; border-radius: 20px; align-self: center !important; margin-top: 100px;">
          <label style="color: white; margin-top: 5px;">ชำระเงิน</label>
        </div>
    </b-col>
   
  </b-row>


<!-- ////// Modal /////// -->
     <b-modal ref="my-modal" centered hide-footer title="เลือกวิธีการชำระ">
       <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
 <div class="mx-auto">
      <h5 style="color: #68C191;">เลือกวิธีการชำระเงิน</h5>
 </div>

    </template>
      <div class="d-block text-center">
          
           <b-row class="text-center" align-v="center">
    <b-col >
        <span @click="$router.push({ name: 'CreditCard', params: { 
          aid: $route.query.aid,
          pt: 'CreditCard',
          type: $route.query.type,
          pid: $route.query.pid,
          at: $route.query.at,
        }})" style="color: black;">Credit Card</span>
    </b-col>
    </b-row >
<hr>
              <b-row class="text-center mt-4" align-v="center">
    <b-col >
        <span @click="getQrPromptpay"
        style="color: black;">QR Promptpay</span>
    </b-col>
    </b-row >
 
      </div>
    </b-modal>
<!-- {{card}}
{{this.packageData}} -->

</div>
        <!-- <img src="../assets/images/fahfon/banner-plus.png"> -->


</template>

<script>


import axios from 'axios'
// import CardForm from '@/components/CardForm'
export default {
  name: 'paymentdetail',
  components: {
    // CardForm
  },
  data () {
    return {
      bannerPath: '',
      packageData: {},
      card: {}
    }
  },
   methods: {
     async getQrPromptpay(){
 
              this.$router.push({ name: 'QR', params: { 
          aid: this.$route.query.aid,
          type: this.$route.query.type,
          pid: this.$route.query.pid,
          at: this.$route.query.at,
        }})



     },
     async paymentSubmitCredit(){

        var paymentTypeSet = ''
        var packageId = ''



        if (this.$route.query.pt === 'CreditCard') {
            paymentTypeSet = 'CreditCard'
        }
        else {
            return;
        }

        if (this.$route.query.type === 'Plus')
            packageId = this.packageData.plus
        else if (this.$route.query.type === 'Farm')
            packageId = this.packageData.farm
        else
            return;


        // var expires = this.card.expiration.split('/')
 this.$loading(true)

        const paramsBody = new URLSearchParams()
        paramsBody.append('card[name]', this.card.cardName)
        paramsBody.append('card[number]', this.card.cardNumberNotMask)
        paramsBody.append('card[expiration_month]',this.card.cardMonth)
        paramsBody.append('card[expiration_year]', this.card.cardYear)
        paramsBody.append('card[security_code]', this.card.cardCvv)

try{
        var resultTokenCard = await this.getTokenCreditCard(paramsBody)

 if (resultTokenCard.status === 200) {
        

          var transectionbody = {
                token: resultTokenCard.data.id,
                payload: resultTokenCard.data,
                audience: '0jSRCeScRxUkZxUnIzB4/crAWrjlMsQ62T6FpPoy9x5iv9ualMDYtg=='
            }

 

        var resultPayment = await axios({
                method: "post",
                processData: true,
                // contentType: "text/plain",
                cache: false,
                url: `https://api.fahfon.info/api/Accounts/${this.$route.query.aid}/payments/${this.$route.query.pt}/packages/${this.packageData.id}`,
                data: transectionbody,
                headers: {
                  'Accept': '*/*',
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.$route.query.at}` 
                }
              })

              this.$loading(false)

             

              if (resultPayment.status === 201) {
                  
                    if (resultPayment.data.authorize_uri !== undefined && resultPayment.data.authorize_uri !== '' && resultPayment.data.authorize_uri !== null) {
                            window.location.href = resultPayment.data.authorize_uri
                        }
                }


           
 }
 else
 {
   this.$loading(false)
   alert('เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง (-1)')
 }
     
     }
catch(err)
{

  alert('เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง (-2)')
     this.$loading(false)

}
     },
      async getTokenCreditCard (params) {
 
// var credentials = 'cGtleV90ZXN0XzVuc3dyeXY0dDVwZWZkcmFsaGg6'
var credentials = 'cGtleV81b3ZjZ3B1dnR1NGljbTQxcXF5Og=='
            return await axios({
                method: "post",
                processData: false,
                contentType: "application/x-www-form-urlencoded",
                cache: false,
                url: `https://vault.omise.co/tokens`,
                data: params,
                headers: {
                  'Accept': '*/*',
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': `Basic ${credentials}` 
                }
              })
},
     getHiddenCreditCard(text) {

        var loopCount = text.length - 7
        var numberLastCredit = text.substr(text.length - 4); // => "Tabs1"
        var starText = ''
        for (var i = 0; i < loopCount; i++) {
            starText = `${starText}*`
        }
        return `${starText}${numberLastCredit}`
    },
      getDecode(val){
       return atob(val)
      },
      showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        this.$refs['my-modal'].hide()
      },
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        this.$refs['my-modal'].toggle('#toggle-btn')
      }
    },
  mounted(){
    this.$loading(false)
    var isContinue = true

    if(
      this.$route.query.aid === undefined ||
      this.$route.query.type === undefined ||
      this.$route.query.pid === undefined ||
      this.$route.query.at === undefined 
    )
    {
    isContinue = false
      window.location.href = 'https://fahfon.info'
    } 

    if(this.$route.query.c !== undefined)
    {
     
      this.card = JSON.parse(this.getDecode(this.$route.query.c))
 
    }

    if(this.$route.query.type === 'Plus')
    {
        this.bannerPath = require('../assets/images/fahfon/banner-plus.png')
    }
    else if(this.$route.query.type === 'Farm')
    {
        this.bannerPath = require('../assets/images/fahfon/banner-farm.png')

    }
    else
    {
          isContinue = false
    }

if(isContinue)
{
    const config = {
         headers: {
             "Content-type": "application/json",
              "Authorization": `Bearer ${this.$route.query.at}`,
         },
};  

var vm = this
      axios.get(`https://api.fahfon.info/api/packages/${this.$route.query.pid}`,null, config)
  .then(function (response) {
    if(response.status === 200)
      vm.packageData  = response.data
  })
  .catch(function (error) {
    // handle error
      window.location.href = 'https://fahfon.info'
  })
  }
  }

}
</script>


